import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Agents from "./pages/Agents.js";
import Roles from "./pages/Roles";
import Permissions from "./pages/Permissions";
import Clients from "./pages/clients.js";
import AssistedBookings from "./pages/AssistedBookings.js";
import BookingStatusPage  from "./pages/BookingStatusPage.js";
import QuickFormPage from "./pages/QuickFormPage.js";
import BookingDetailsPage from "./pages/BookingDetailsPage.js";
import TLSContactPage from "./pages/TLSContactPage.js";
import VfsAdminControlPage from "./pages/VfsAdminControlPage.js";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import ExtensionLicensePage from "./pages/ExtensionLicensePage";
import AvailableSlotsPage from "./pages/AvailableSlotsPage";
import ProtectedRoute from "./components/ProtectedRoute";
import {
  ADMIN_TAB_LOCKS_EVENT,
  getFirstUnlockedTabPath,
} from "./utils/adminTabAccess";
import { AUTH_CHANGED_EVENT, isAuthenticated } from "./utils/auth";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => isAuthenticated());
  const [, setTabAccessVersion] = useState(0);

  useEffect(() => {
    const syncAuthState = () => setIsLoggedIn(isAuthenticated());
    const syncTabAccess = () => setTabAccessVersion((version) => version + 1);

    window.addEventListener(AUTH_CHANGED_EVENT, syncAuthState);
    window.addEventListener(ADMIN_TAB_LOCKS_EVENT, syncTabAccess);
    window.addEventListener("storage", (event) => {
      if (event.key === "token") {
        syncAuthState();
      }
      syncTabAccess();
    });

    return () => {
      window.removeEventListener(AUTH_CHANGED_EVENT, syncAuthState);
      window.removeEventListener(ADMIN_TAB_LOCKS_EVENT, syncTabAccess);
    };
  }, []);

  const defaultUnlockedPath = getFirstUnlockedTabPath() || "/dashboard";

  const wrapProtected = (path, element) => (
    <ProtectedRoute path={path}>{element}</ProtectedRoute>
  );

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            isLoggedIn ? <Navigate to={defaultUnlockedPath} replace /> : <LandingPage />
          }
        />
        <Route
          path="/login"
          element={
            isLoggedIn ? (
              <Navigate to={defaultUnlockedPath} replace />
            ) : (
              <Login onLoginSuccess={() => setIsLoggedIn(true)} />
            )
          }
        />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/admin/jasim/12345" element={<VfsAdminControlPage />} />
        <Route
          path="/register"
          element={isLoggedIn ? <Navigate to={defaultUnlockedPath} replace /> : <Register />}
        />
        <Route path="/dashboard" element={wrapProtected("/dashboard", <Dashboard />)} />
        <Route path="/Permissions" element={wrapProtected("/permissions", <Permissions />)} />
        <Route path="/roles" element={wrapProtected("/roles", <Roles />)} />
        <Route path="/Agents" element={wrapProtected("/Agents", <Agents />)} />
        <Route path="/Clients" element={wrapProtected("/Clients", <Clients />)} />
        <Route path="/AssistedBookings" element={wrapProtected("/AssistedBookings", <AssistedBookings />)} />
        <Route path="/BookingStatusPage" element={wrapProtected("/BookingStatusPage", <BookingStatusPage />)} />
        <Route path="/quick-form" element={wrapProtected("/quick-form", <QuickFormPage />)} />
        <Route path="/booking-details" element={wrapProtected("/booking-details", <BookingDetailsPage />)} />
        <Route
          path="/available-slots"
          element={wrapProtected("/available-slots", <AvailableSlotsPage />)}
        />
        <Route path="/tls-form" element={wrapProtected("/tls-form", <TLSContactPage />)} />
        <Route
          path="/extension-license"
          element={wrapProtected("/extension-license", <ExtensionLicensePage />)}
        />
        <Route
          path="*"
          element={isLoggedIn ? <Navigate to={defaultUnlockedPath} replace /> : <Navigate to="/" replace />}
        />
      </Routes>
    </Router>
  );
}

export default App;
